<template>
    <card-sections :title="Lang.get('employerdashboard::pages/settings/profile.edit.title')"
                   :subtitle="Lang.get('employerdashboard::pages/settings/profile.edit.subtitle')" :hideMsg="true" :tabName="'profile'">

        <form @submit.prevent="submit()">
            <div class="tab-pane fade py-4 show active" id="v-pills-profile"
                 role="tabpanel" aria-labelledby="v-pills-profile-tab">
                <flash-messages :hideErrors="true"></flash-messages>

                <div class="row">
                    <div class="form-group col-md-4">
                        <text-input
                            v-model="form.firstname"
                            :label="Lang.get('employerdashboard::shared.firstname')"
                            :placeholder="Lang.get('employerdashboard::shared.placeholder.firstname')"
                            :error="errors.firstname"
                            :isValidated="isValidated"
                        />
                    </div>
                    <div class="form-group col-md-4">
                        <text-input
                            v-model="form.middlename"
                            :label="Lang.get('employerdashboard::shared.middlename')"
                            :placeholder="Lang.get('employerdashboard::shared.placeholder.middlename')"
                            :error="errors.middlename"
                        />
                    </div>
                    <div class="form-group col-md-4">
                        <text-input
                            v-model="form.lastname"
                            :label="Lang.get('employerdashboard::shared.lastname')"
                            :placeholder="Lang.get('employerdashboard::shared.placeholder.lastname')"
                            :error="errors.lastname"
                            :isValidated="isValidated"
                        />
                    </div>
                </div>
                <div class="form-group mt-4">
                    <label for="currentPassword" class="font-poppins w-100 color-dark-blue">
                        {{ Lang.get('employerdashboard::shared.current_password') }}
                    </label>

                    <input
                        id="currentPassword"
                        v-model="form.current_password"
                        type="password"
                        class="form-control font-poppins"
                        :placeholder="Lang.get('employerdashboard::shared.placeholder.current_password')"
                        autocomplete="current-password">
                    <form-error :error="errors.current_password"></form-error>

                </div>

                <div class="form-group mt-4">
                    <label for="currentPassword" class="font-poppins w-100 color-dark-blue">
                        {{ Lang.get('employerdashboard::shared.change_password') }} ?
                    </label>
                    <button type="button" v-model="changePassword" @click="changePassword = true"
                            class="btn btn-info">
                        {{ Lang.get('employerdashboard::shared.yes') }}
                    </button>
                    <button type="button" v-model="changePassword" @click="changePassword = false"
                            class="btn btn-info">
                        {{ Lang.get('employerdashboard::shared.no') }}
                    </button>
                </div>

                <template v-if="changePassword">
                    <div class="form-group mt-4">
                        <label for="employerPassword" class="font-poppins w-100 color-dark-blue">
                            {{ Lang.get('employerdashboard::shared.new_password') }}
                            <a @click="showOrHidePasswordValue('password')">
                                <span class="float-right cursor-pointer link-show">
                                    <img :src="passwordType === 'password' ? '/img/login/icon-show.svg' : '/img/login/icon-hide.svg'">
                                    {{ passwordType === 'password'
                                    ? Lang.get('employerdashboard::shared.show')
                                    : Lang.get('employerdashboard::shared.hide') }}
                                </span>
                            </a>
                        </label>
                        <input
                            v-model="form.password"
                            :type="passwordType"
                            class="form-control font-poppins password-check"
                            id="employerPassword"
                            :error="errors.password"
                            :placeholder="Lang.get('employerdashboard::shared.placeholder.new_password')"
                            autocomplete="new-password">
                        <div v-if="errors && Array.isArray(errors.password)" class="form-error">{{ errors.password.join(',') }}</div>
                        <div v-if="errors && errors.password instanceof String" class="form-error">{{ errors.password }}</div>

                        <password-validation :inputVal="form.password"/>

                    </div>
                    <div class="form-group mt-4 mb-5">
                        <label for="employerPassword2"
                               class="font-poppins w-100 color-dark-blue">
                            {{ Lang.get('employerdashboard::shared.password_confirm') }}

                            <a @click="showOrHidePasswordValue('passwordConfirm')">
                                <span class="float-right cursor-pointer link-show">
                                    <img :src="passwordConfirmType === 'password' ? '/img/login/icon-show.svg' : '/img/login/icon-hide.svg'">
                                    {{ passwordConfirmType === 'password'
                                    ? Lang.get('employerdashboard::shared.show')
                                    : Lang.get('employerdashboard::shared.hide') }}
                                </span>
                            </a>
                        </label>
                        <input
                            v-model="form.password_confirmation"
                            :type="passwordConfirmType"
                            class="form-control font-poppins"
                            :class="passwordConfirmEqualsPassword ? 'is-valid' : ''"
                            id="employerPassword2"
                            :error="errors.password_confirmation"
                            :placeholder="Lang.get('employerdashboard::shared.placeholder.password_confirm')"
                            autocomplete="current-password">

                        <div v-if="errors && Array.isArray(errors.password_confirmation)" class="form-error">{{ errors.password_confirmation.join(',') }}</div>
                        <div v-if="errors && errors.password_confirmation instanceof String" class="form-error">{{ errors.password_confirmation }}</div>
                    </div>
                </template>
                <button
                    type="submit"
                    class="btn btn-primary btn-orange font-poppins font-weight-bold color-white border-radius-19 px-5 mt-4">
                    {{ Lang.get('employerdashboard::shared.save.button') }}
                </button>
            </div>
        </form>
    </card-sections>
</template>

<script>
import CardSections from "@/Pages/Settings/Shared/CardSections";
import TextInput from "@/Shared/TextInput";
import throttle from "lodash/throttle";
import Checkbox from "@/Shared/Checkbox";
import FormError from "@/Shared/FormError";
import FlashMessages from "@/Shared/FlashMessages";
import PasswordValidation from "@/Shared/PasswordValidation.vue";

export default {
    metaInfo: { title: Lang.get('employerdashboard::pages/settings/profile.title') },
    components: {
        CardSections,
        FormError,
        Checkbox,
        TextInput,
        FlashMessages,
        PasswordValidation
    },
    props: {
        errors: Object,
        profile: Object,
        isValidated: Object,
    },

    data() {
        return {
            passwordType: 'password',
            passwordConfirmType: 'password',
            passwordConfirmEqualsPassword: false,
            changePassword: false,
            form: {
                uuid: this.profile.uuid,
                firstname: this.profile.firstname,
                middlename: this.profile.middlename,
                lastname: this.profile.lastname,
                current_password: null,
                password: null,
                password_confirmation: null,
            },
        }
    },
    methods: {
        submit() {
            let form = this.form;
            if (!this.form.password) {
                form = {
                    uuid: this.form.uuid,
                    firstname: this.form.firstname,
                    middlename: this.form.middlename,
                    lastname: this.form.lastname,
                    current_password: this.form.current_password,
                }
            }
            this.$inertia.put(this.route('nl.employerdashboard.settings.profile.update.attempt', this.$page.props.auth.user.selected_company.uuid), form);
        },

        showOrHidePasswordValue(input) {
            switch (input) {
                case 'password':
                    this.passwordType = this.passwordType === 'password' ? 'text' : 'password';
                    break;
                case 'passwordConfirm':
                    this.passwordConfirmType = this.passwordConfirmType === 'password' ? 'text' : 'password';
                    break;
            }
        },

    },
    watch: {
        'form.password': {
            handler: throttle(function() {

                if (this.form.password === this.form.passwordConfirmation) {
                    this.passwordConfirmEqualsPassword = true;
                } else {
                    this.passwordConfirmEqualsPassword = false;
                }

            }, 150),
            deep: true,
        },
    },
}
</script>
